<div class="user-instructions hidden">
  <h1 class="ui-heading-1-bold user-instructions-title">
    {{ knowledgeSection() }}
  </h1>

  <div class="user-instructions-content">
    <div class="ui-body-l" [innerHTML]="userInstructionLongDescription() | safeHtml"></div>
    @for(u of userInstructions(); track $index) {
      @if(u.published === true) {
      <div class="user-instructions-item">
        <h3 class="ui-heading-3">{{ u.title }}</h3>
        <div class="ui-body-l" [innerHTML]="u?.description | safeHtml"></div>
      </div>
      }
    }
  </div>
</div>
